import React from 'react';
import { useState, useEffect } from 'react';
import '../gral-stylesheets/password-reset.scss';



const PasswordReset = (props) => {

  const [email, setEmail] = useState('');
  const [emailChange, setEmailChange] = useState(false);

  useEffect(() => {
    props.joinState || props.loginState || props.passwordResetState || props.successState
      ? document.body.style.overflow = 'hidden'
      : document.body.style.overflow = 'unset'
  }, [props.joinState, props.loginState, props.passwordResetState, props.successState]);

  if (!props.passwordResetState) {
    return null
  }
  return (
    <div
      className='modal-container-overlay'
      onClick={props.passwordResetClose}
    >
      <div
        className='password-reset-box'
        onClick={(e) => e.stopPropagation()}
      >
        <div className='password-reset-header'>
          <div className='password-reset-title'>
            <h3>Password Reset</h3>
          </div>
          <h4>Don't worry, <br /> let's get your password back</h4>
        </div>
        <form className='password-reset-form'>
          <div className='input-container'>
            <label htmlFor='email'>
            <h5
              className={
                emailChange ?
                  'input-label up' : 
                    email !== '' ? 
                    'input-label up' : 'input-label'
              }
            >
              Email
            </h5>
            </label>
            <input
              type='email'
              id='password-reset'
              name='email'
              className='input-password-reset'
              required
              onFocus={() => { setEmailChange(true) }}
              onBlur={(e) => { setEmailChange(false) }}
              onChange={(e) => { setEmail(e.target.value) }}
            />
          </div>
          <div className='input-container'>
            <button
              type='submit'
            >
              <h4>
                Send instructions
              </h4>
            </button>
          </div>
        </form>
        <div className='password-reset-login'>
          <h3>I already remembered my password</h3>
          <p onClick={props.toLogin}>Login here</p>
        </div>
      </div>
    </div>
  )
}

export default PasswordReset;